import styles from "./hortis-loading-logo.module.css";

export const HortisLoadingLogo = () => {
  return (
    <div>
      <div className={styles.loadingIcon}>
        <div className={styles.loadingIconBackground} />
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="0"
          height="0"
          viewBox="0 0 32 32"
          fill="none"
        >
          <defs>
            <clipPath id="svgTextPath">
              <path
                d="M16.0001 6.37626C11.1167 6.37626 7.08177 10.0094 6.45015 14.7205C7.54547 14.8616 8.59662 15.1438 9.58482 15.5482C9.75994 12.1564 12.5652 9.46016 16.0001 9.46016C17.3426 9.46016 18.5888 9.872 19.6195 10.5762L21.8447 8.35074C20.2235 7.11204 18.1978 6.37626 16.0001 6.37626Z"
                fill="#2ED3B7"
              />
              <path
                d="M19.2 16C19.2 17.7673 17.7673 19.2 16 19.2C14.2327 19.2 12.8 17.7673 12.8 16C12.8 14.2327 14.2327 12.8 16 12.8C17.7673 12.8 19.2 14.2327 19.2 16Z"
                fill="#2ED3B7"
              />
              <path
                d="M23.6617 10.168L21.4103 12.4196C21.9951 13.3309 22.3561 14.3997 22.4154 15.5483C23.4035 15.1439 24.4547 14.8617 25.55 14.7205C25.3225 13.0232 24.6532 11.4659 23.6617 10.168Z"
                fill="#2ED3B7"
              />
              <path
                d="M14.7432 2.28882e-08C6.92229 0.605495 0.672045 6.81381 0 14.6168H3.22712C3.87854 8.58944 8.69745 3.81169 14.7432 3.22464V2.28882e-08Z"
                fill="#2ED3B7"
              />
              <path
                d="M17.2568 3.22464C23.3025 3.81169 28.1215 8.58944 28.7729 14.6168H32C31.328 6.81382 25.0778 0.605506 17.2568 0V3.22464Z"
                fill="#2ED3B7"
              />
              <path
                d="M31.9857 17.4102C31.3244 25.1571 25.1484 31.3322 17.3965 32V27.1869C17.3965 21.7874 21.7732 17.4102 27.1721 17.4102H31.9857Z"
                fill="#2ED3B7"
              />
              <path
                d="M14.6036 32C6.8517 31.3322 0.675708 25.1571 0.0144618 17.4102H4.82802C10.2269 17.4102 14.6036 21.7874 14.6036 27.1869V32Z"
                fill="#2ED3B7"
              />
            </clipPath>
          </defs>
        </svg>
      </div>
    </div>
  );
};
